module.exports = __webpack_public_path__ + "img/768_banner_1.3ec5d714.jpg";